/**
 * @generated SignedSource<<4b2e98179a30c62a66107b0df4c93748>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Layout_User$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"Sidebar_User">;
  readonly " $fragmentType": "Layout_User";
};
export type Layout_User$key = {
  readonly " $data"?: Layout_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"Layout_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Layout_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Sidebar_User"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "ad463579ef1ae74484358ed53d55ece0";

export default node;
